import DeliveryOptionBuilder from '@/builder/delivery-option/DeliveryOptionBuilder';
import TestConverter from '@/builder/TestConverter';
import TestModelBuilder from '@/builder/TestModelBuilder';
import Utility from '@/util/Utility';
import FormController from '../form/FormController';
import NavigationController from '../navigation/NavigationController';
import StateController from '../state/StateController';
import TestController from '../TestController';
import ITestControllerInitializationStrategy from './ITestControllerInitializationStrategy';

class PracticeTestInitializationStrategy implements ITestControllerInitializationStrategy {
  initialize(qtiSessionId: string, sessionId: string, formId: string, testController: TestController): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      testController.stateController = new StateController();
      testController.formController = new FormController(formId, testController!.baseServiceUrl);
      testController.formController
        .initialize()
        .then(() => {
          testController.test = new TestModelBuilder(testController.baseServiceUrl).build(
            testController.formController!.formData.get('qti')! as string,
            Utility.convertToArrayOfMaps(testController.formController!.formData.get('qti_items')! as Array<never>)
          );
          new DeliveryOptionBuilder().build(testController, true);

          testController.navigationController = new NavigationController(
            TestConverter.convertTest(testController.test!),
            testController
          );

          resolve();
        })
        .catch((error) => reject(error));
    });
  }
}

export default PracticeTestInitializationStrategy;
